"use client";

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

// Extend the Window interface to include _paq
declare global {
  interface Window {
    _paq?: (string[] | number[])[];
    __matomoInitialized?: boolean;
  }
}

// Rename the component to reflect its new focus on tracking page views on navigation
function MatomoPageviewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const matomoUrl = process.env.NEXT_PUBLIC_MATOMO_URL;
    const siteId = process.env.NEXT_PUBLIC_MATOMO_SITE_ID;

    if (!matomoUrl || !siteId) {
      // console.warn("Matomo URL or Site ID is not configured. Page view tracking disabled.");
      return; // Don't track if not configured
    }

    // Ensure _paq array is available (it should be initialized by the script in layout.tsx)
    const _paq = (window._paq = window._paq || []);

    // Remove the one-time initialization logic (moved to layout.tsx)
    /*
    if (!window.__matomoInitialized) {
        _paq.push(['setTrackerUrl', `${matomoUrl}tced.php`]);
        _paq.push(['setSiteId', siteId]);
        _paq.push(["disableCookies"]); 
        _paq.push(['enableLinkTracking']);
        window.__matomoInitialized = true; 
    }
    */

    // Construct the full URL for Matomo tracking, including search parameters
    const currentUrl = `${pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;

    // Set the current URL and trigger a page view event for navigation changes
    // This relies on the main tracker being initialized by the script in layout.tsx
    _paq.push(['setCustomUrl', currentUrl]); 
    _paq.push(['trackPageView']);

    // console.log(`[MatomoPageviewTracker] Tracked page view for: ${currentUrl}`);

  }, [pathname, searchParams]); // Re-run this effect whenever the pathname or search params change

  return null; // This component does not render any visible UI
}

export default MatomoPageviewTracker; 